var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['home-ad-type',{blackColor:_vm.blackcolor}]},[_c('h2',[_vm._v(_vm._s(_vm.typeTitle))]),_c('p',[_vm._v(_vm._s(_vm.typeDetail))]),_c('img',{attrs:{"src":_vm.url,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }